import React, { useEffect, useState } from 'react';
import { ChartsDataDistribution, LimiaresParaOsGraficos } from '../../config/api/index.js';
import { getColorForLimiar, serieCampanhaColor, getPlotlyPlot, getAmostraTipos, getNomeLimiarSerieOuAmostraParaGraficoDeDistribuicao } from './ChartsUtils.js';
import ReactResizeDetector from 'react-resize-detector';

var state;
var jsx = null;

const Histogramly = (props) => {
    //Get localized reac-plotly plot
    const Plot = getPlotlyPlot();

    const [data, setData] = useState([]);
    const [limiares, setLimiares] = useState([]);
    const [siz, setSiz] = useState({});

    const [forceupdate, setForceUpdate] = useState({});

    const graph = (props) => {
        if (!state || forceupdate) {
            state = getNewPlot(props);
            setForceUpdate(false);
            jsx = null;
        }
        return getOldPlot();
    }

    function getNewPlot(props) {
        return (
            {
                data: [...data, ...limiares],
                layout: {
                    width: siz.width,
                    height: siz.height,
                    barmode: 'overlay',
                    //yaxis: { showticklabels: true },
                    //xaxis: { type: axisType },//xaxis: {type:'log'},
                    xaxis: { title: { text: "VALOR" } },
                    yaxis: { title: { text: "QUANTIDADE" }, showticklabels: true },
                    //
                    yaxis2: {
                        overlaying: 'y',
                        range: [0, 1],
                        showticklabels: false,
                    },
                    xaxis2: {
                        showticklabels: false
                    },
                    showlegend: true,
                    legend: {
                        orientation: 'h',
                        x: 1.02, y: 1,
                        bgcolor: '#eceeee'
                    },
                    margin: { l: 50, r: 10, b: 34, t: 10, pad: 4 }
                },
                config: {
                    locale: "pt-BR",
                    displaylogo: false,
                    displayModeBar: false,
                    modeBarButtonsToRemove: ['sendDataToCloud', 'hoverCompareCartesian', 'hoverClosestCartesian', 'lasso2d', 'select2d', 'autoScale2d']
                }
            }
        );
    }

    function getOldPlot() {
        if (!jsx) {
            jsx = (
                <Plot
                    data={state.data}
                    layout={state.layout}
                    config={state.config}
                />
            );
        }
        return jsx;
    }

    useEffect(() => {
        (async () => {
            if (!props.parametroSerie) return
            let dat = [];
            let tickvals = [];
            const data = await ChartsDataDistribution(props.parametroSerie.parametro, props.parametroSerie.seriesHabilitadas)
            data.series.forEach(element => {
                dat.push(
                    {
                        type: 'histogram',
                        opacity: 0.6,
                        x: element.data,
                        name: element.nomeSerie + ((element.unidade === null) ? ' ' : (' - (' + element.unidade + ')')),
                        marker: { color: serieCampanhaColor((element.nomeSerie)) },
                        seriesid: element.idSerie
                    }
                );
                tickvals.push(element.unidade);
            });
            setData(dat);
            setForceUpdate(true);
        })()
    }, [props.parametroSerie])

    useEffect(() => {
        (async () => {
            if (!props.parametroSerie || !props.tipoLimiarSelecionado) return
            const tipoLimiarIds = props.tipoLimiarSelecionado.map(limiar => limiar.id);
            const tipoAmostraIds = getAmostraTipos();
            //get valores de limiares selecionados do servidor
            const lims = await LimiaresParaOsGraficos(props.parametroSerie.parametro, tipoAmostraIds, tipoLimiarIds)
            //calculate starting and ending Y
            let limiars = [];
            //load elementes to put into layout.shapes
            lims.forEach(element => {
                limiars.push(
                    {
                        mode: 'lines',
                        type: 'scatter',
                        name: getNomeLimiarSerieOuAmostraParaGraficoDeDistribuicao(element),
                        x: [element.valor, element.valor],
                        y: [0, 0.95],
                        yaxis: 'y2',
                        xaxis2: 'x2',
                        line: {
                            color: getColorForLimiar(element.tipo, element.superior),
                            width: 2,
                            dash: 'dot'
                        }
                    }
                );
            });
            setLimiares(limiars);
            setForceUpdate(true);
        })()
    }, [props.parametroSerie, props.tipoLimiarSelecionado])

    const onResize = (width, height) => {
        setSiz({ width: width, height: height });
        setForceUpdate(true);
    }

    return (
        <div style={{ position: "absolute", width: "98%", height: "94%" }}>
            {graph(props)}
            <ReactResizeDetector handleWidth handleHeight onResize={onResize} />
        </div>
    );

}

export default Histogramly;